import { IOpsEnviron } from 'types/opsToday.interface'

export const OPS_ENVIRON: IOpsEnviron = {
  blastWindows: [{ id: 1, zone: 'Pit B', from: '14:00', to: '15:00', state: 'scheduled' }],
  weather: { summary: 'Clear', tempC: 28, windKmh: 12, liftsOk: true, roadsOk: true },
}

export const OPS_PACE_HISTORY = [88, 92, 95, 90, 93]

export const OPS_AVAIL_HISTORY = [83, 100, 100, 67, 67]
